import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { visitorMessages } from 'src/features/visitor/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { ActiveStay, STAY_TYPE, VISITOR_CATEGORY } from 'src/features/stay/types';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';
import ExitFromParkingFormModal from 'src/features/stay/components/forms/ExitFromParkingFormModal';
import { PATH } from 'src/features/navigation/utils/constants';
import ConvertActiveStayToMembershipModal from 'src/features/stay/components/forms/ConvertActiveStayToMembershipModal';

type ActiveStaySidePanelButtonsProps = {
    stayId?: string;
    stayType: STAY_TYPE;
    stay?: ActiveStay;
};

const ActiveStaySidePanelButtons = ({ stayId, stayType, stay }: ActiveStaySidePanelButtonsProps) => {
    const { formatMessage } = useIntl();
    const navigate = useNavigate();
    const manageActiveStays = useHasPermissions([PERMISSION.MANAGE_ACTIVE_STAYS]);
    const manageMembership = useHasPermissions([PERMISSION.MANAGE_MEMBERSHIPS]);

    const activePastStayUrlPart = stayType === 'active' ? 'active-stay' : 'past-stay';
    const isActiveStayClient = Boolean(
        stayType === STAY_TYPE.ACTIVE && stay?.period_visitor_category === VISITOR_CATEGORY.CLIENT,
    );

    return (
        <>
            <div className="grid gap-2">
                <Button
                    variant="outline"
                    className="cursor-pointer"
                    onClick={() =>
                        stayId &&
                        navigate(`/${PATH.VISITORS}/${activePastStayUrlPart}/dashboard/${stayId}?type=${stayType}`)
                    }
                >
                    {formatMessage(visitorMessages.openStayDashboard)}
                </Button>
                {isActiveStayClient && manageMembership && (
                    <ConvertActiveStayToMembershipModal selectedActiveStay={stay}>
                        <Button className="cursor-pointer">{formatMessage(visitorMessages.convertActiveStay)}</Button>
                    </ConvertActiveStayToMembershipModal>
                )}
                {stayType === STAY_TYPE.ACTIVE && stay && manageActiveStays && (
                    <ExitFromParkingFormModal activeStay={stay}>
                        <Button className="cursor-pointer" variant="destructiveLight">
                            {formatMessage(visitorMessages.exitFromParking)}
                        </Button>
                    </ExitFromParkingFormModal>
                )}
            </div>
        </>
    );
};

export default ActiveStaySidePanelButtons;
